/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */
import { globalBreak } from '@/styles/break';
import { SxProps } from '@mui/material';

export const productCardNameSX: SxProps = {
	display:'-webkit-box',
	WebkitLineClamp:2,
	WebkitBoxOrient:'vertical',
	overflow:'hidden',
	textAlign:'left',
	fontSize:globalBreak({mobile:12, desktop:16}),
	minHeight:globalBreak({mobile:'3em', desktop:'2em'}),
	lineHeight:1.2,
	wordBreak:'break-word'
};
